// extracted by mini-css-extract-plugin
module.exports = {"ViewDetails":"BatchRepaymentRequest_ViewDetails__2Jl8G"};